import { constructorParametersDownlevelTransform } from '@angular/compiler-cli';
import { Component, Injector, OnInit } from '@angular/core';
import { PlanoTrabalhoDaoService } from 'src/app/dao/plano-trabalho-dao.service';
import { UnidadeDaoService } from 'src/app/dao/unidade-dao.service';
import { UsuarioDaoService } from 'src/app/dao/usuario-dao.service';
import { PlanoTrabalho } from 'src/app/models/plano-trabalho.model';
import { PageListBase } from 'src/app/modules/base/page-list-base';
import { AuthService } from 'src/app/services/auth.service';
import { NavigateService } from 'src/app/services/navigate.service';

@Component({
  selector: 'app-report-spreedsheet-modal',
  templateUrl: './report-spreedsheet-modal.component.html',
  styleUrls: ['./report-spreedsheet-modal.component.scss']
})
export class ReportSpreedsheetModalComponent extends PageListBase<PlanoTrabalho, PlanoTrabalhoDaoService> {
  
  public go : NavigateService;
  public auth : AuthService;
  public unidadeDao: UnidadeDaoService;
  public usuarioDao: UsuarioDaoService;
  public params?: any;
  
  constructor(public injector: Injector) {
    super(injector, PlanoTrabalho, PlanoTrabalhoDaoService);
    this.auth = injector.get<AuthService>(AuthService)
    this.go = this.injector.get<NavigateService>(NavigateService);
    this.unidadeDao = injector.get<UnidadeDaoService>(UnidadeDaoService)
    this.usuarioDao = this.injector.get<UsuarioDaoService>(UsuarioDaoService);
  }

  public ngOnInit() {
    super.ngOnInit();
    this.params = this.metadata?.params;
    console.log(this.params);
  }


}
